import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { DistributorsService } from 'src/app/services/distributors.service';
import { Alert } from 'src/app/shared/models/Alert';
import { ResponseDataFile } from 'src/app/shared/models/ApiResponse';
import { SimpleRequestDTO } from 'src/app/shared/models/SimpleRequest';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { saveAs } from 'file-saver';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CreateDistributorsComponent } from '../create-distributors/create-distributors.component';
import { TooltipDirective } from '../../../directives/tooltip.directive';
import { SearchPipe } from '../../../pipes/search.pipe';

@Component({
    selector: 'app-list-distributors',
    templateUrl: './list-distributors.component.html',
    styleUrls: ['./list-distributors.component.css'],
    imports: [
        CommonModule,
        FormsModule,
        CreateDistributorsComponent,
        TooltipDirective,
        SearchPipe
    ]
})
export class ListDistributorsComponent {
  distributors: UserDTO[] = [];
  originalDistributors: UserDTO[] = [];
  filterValue: string = 'option1';
  currentPage: number = 1;
  recordsPerPage: number = 10;
  totalPages: number = 0;
  pagesToShow: number = 5;
  textoBusqueda: string = '';
  camposBusqueda: string[] = [
    'userId',
    'userNames',
    'userMail',
    'userPhone',
    'totalPartners',
    'totalCustomers',
  ];
  isFilteredByStatus: boolean = false;
  selectedDistributor: UserDTO | any = {} as UserDTO;
  isConfirmationModalOpen: boolean = false;
  requestLong: SimpleRequestDTO = {} as SimpleRequestDTO;
  alert: Alert = {} as Alert;

  constructor(
    private distributorsService: DistributorsService,
    private router: Router,
    private route: ActivatedRoute,
    private customerService: CustomerService,
    private alertService: AlertService,
    public permissionsService: ValidatePermissionsService
  ) {}

  ngOnInit() {
    // Уже не нужно вызывать this.permissionsService.validateAccessLevels(MODULE_ID); при инициализации модуля, т.к. это делается автоматически в AuthorizationGuard
    //this.permissionsService.validateAccessLevels(MODULE_ID.Distributors);
    //this.permissionsService.userHasPermission(MODULE_ID.Customers, [PERMISSION.Create]).subscribe(r => this.allowCreateCustomers = r);
    //this.allowCreateCustomers = this.permissionsService.customers.createPermission;

    this.distributorsService.getListDistributors().subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {
          this.handleGetListDistributors(Data);
        } else {
          this.handleGetListDistributorsError(StatusCode);
        }
      },
      () => {
        this.errorMessage();
      }
    );
    document.documentElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  get pages(): number[] {
    const start = Math.max(1, this.currentPage - Math.floor(this.pagesToShow / 2));
    const end = Math.min(this.totalPages, start + this.pagesToShow - 1);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  nextPage() {
    if (this.currentPage * 10 < this.distributors.length) {
      this.currentPage++;
    }
  }

  getRange(): string {
    const startIndex = (this.currentPage - 1) * 10 + 1;
    const endIndex = Math.min(this.currentPage * 10, this.distributors.length);
    return `${startIndex} - ${endIndex}`;
  }

  handleGetListDistributorsError(StatusCode: number) {
    this.errorMessage();
  }

  handleGetListDistributors(users: UserDTO[]) {
    this.distributors = users;
    this.originalDistributors = this.distributors.slice();
    this.distributors = this.originalDistributors.filter(d => d.userStatus === 0 || d.userStatus === 1);
    this.totalPages = Math.ceil(this.distributors.length / 10);
  }

  updatePagination(): void {
    if (!this.textoBusqueda) {
      this.totalPages = Math.ceil(this.distributors.length / this.recordsPerPage);
    }

    const searchCriteria = this.textoBusqueda.split(',').map(c => c.trim().toLowerCase());

    const filteredList = this.distributors.filter(item =>
      this.camposBusqueda.some(field => {
        const fieldValue = (item as any)[field];
        if (fieldValue !== undefined && fieldValue !== null) {
          return searchCriteria.some(c => fieldValue.toString().toLowerCase().includes(c));
        }
        return false;
      })
    );

    this.totalPages = Math.ceil(filteredList.length / this.recordsPerPage);
    this.currentPage = 1;
  }

  onSearchChange(): void {
    this.updatePagination();
  }

  filterByStatus(status: number) {
    this.distributors = this.originalDistributors.slice();
    if (!this.isFilteredByStatus) {
      this.originalDistributors = this.distributors.slice();
      this.isFilteredByStatus = true;
    }
    this.distributors = this.originalDistributors.filter(d => d.userStatus === status);
    this.updatePagination();
  }

  clearFilter() {
    this.isFilteredByStatus = false;
    this.distributors = this.originalDistributors.slice();
    this.distributors = this.distributors.filter(d => d.userStatus === 0 || d.userStatus === 1);
    this.updatePagination();
  }

  setSelectedDistributor(user: UserDTO) {
    this.selectedDistributor = user;
  }

  setArchivedDistributor(user: UserDTO) {
    this.selectedDistributor = user;
    this.selectedDistributor['@userStatus'] = this.isFilteredByStatus ? 1 : 2;
  }

  toggleStatus(event: any, distributor: any) {
    distributor.userStatus = event.target.checked ? 1 : 0;
    const index = this.originalDistributors.findIndex(d => d.userId === distributor.userId);
    if (index !== -1) {
      this.originalDistributors[index].userStatus = distributor.userStatus;
    }
  }

  openConfirmationModal(user: UserDTO) {
    this.selectedDistributor = user;
    this.isConfirmationModalOpen = true;
  }

  async closeConfirmationModal() {
    this.isConfirmationModalOpen = false;
    location.reload();
  }

  updateDistributorStatus(confirmed: boolean) {
    if (confirmed) {
      if (typeof this.selectedDistributor['@userStatus'] === 'number') {
        this.selectedDistributor.userStatus = this.selectedDistributor['@userStatus'];
      }
      this.customerService.updateCustomerStatus(this.selectedDistributor).subscribe(
        ({ StatusCode, Message, Data }) => {
          if (Data != null) {
            this.handleUpdateDistributorStatus(Data);
          } else {
            this.handleUpdateDistributorStatusError(StatusCode);
          }
        },
        () => {
          this.errorMessage();
        }
      );
    } else {
      location.reload();
    }
  }

  handleUpdateDistributorStatusError(StatusCode: number) {
    this.errorMessage();
  }

  async handleUpdateDistributorStatus(result: boolean) {
    this.clearPartnersDistributor();
    this.alert = {
      alertMessage: 'Distributor status updated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(this.alert);
    location.reload();
  }

  clearPartnersDistributor() {
    this.requestLong.id = this.selectedDistributor.userId;

    this.distributorsService.clearPartnersDistributor(this.requestLong).subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {
          this.handleClearPartnersDistributor(Data);
        } else {
          this.handleUpdateDistributorStatusError(StatusCode);
        }
      },
      () => {
        this.errorMessage();
      }
    );
  }

  async handleClearPartnersDistributor(result: boolean) {
    this.errorMessage();
    await new Promise(resolve => setTimeout(resolve, 1));
    document.documentElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
    await new Promise(resolve => setTimeout(resolve, 3000));
    location.reload();
  }

  navigateToDistributorAccount(user: UserDTO) {
    this.router.navigate([`/distributors/distributor-account/${user.userId}`], {
      relativeTo: this.route,
      state: { distributorData: user },
    });
  }

  navigateToDistributorView(distributor: UserDTO) {
    this.router.navigate(['/distributors/view-distributor', distributor.userId]);
  }


  navigateToDistributorStaff(distributor: any) {
    this.router.navigate(['/distributors/distributor-staff'], {
      relativeTo: this.route,
      state: { distributorData: distributor },
    });
  }


  exportListDistributorsToExcel() {
    this.distributorsService.exportToExcelListDistributors().subscribe(
      (response: ResponseDataFile) => {
        if (response) {
          this.handleDownload(response);
        } else {
          this.handleGetFileError();
        }
      },
      (error) => {
        console.error('Error exporting Excel file:', error);
      }
    );
  }

  private handleDownload(data: ResponseDataFile) {
    const byteCharacters = atob(data.Data.fileContents);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: data.Data.contentType });
    saveAs(blob, data.Data.fileDownloadName || 'export.xlsx');

    this.alert = {
      alertMessage: 'File generated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(this.alert);
  }

  private handleGetFileError() {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(this.alert);
  }

  errorMessage() {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(this.alert);
  }
}
